import React, { useEffect } from 'react';
import { theme } from '../../theme';
import Card from '../../components/common/Card';
import { useMessageGetter } from 'react-message-context';
import styled from 'styled-components/macro';
import { H6 } from '../../components/common/Text';
import { FlexColumn } from '../../components/basic/Flex';
import { LinkButton } from '../../components/common';
import { getMenuItemPathBySlug } from '../../utils/wordpress';
import { Slugs } from '../../constants/knownSlugs';
import { useApp } from '../../context/appContext';
import { useKennoTenant } from '../../context/kennoTenantContext';
import { loadBuilding } from '../../context/kennoTenantActions';
import { LOAD_STATES } from '../../context/common';
import Loader from '../../components/basic/Loader';
import { Divider } from '../../components/common/Divider';

const TextContainer = styled.div`
  margin: 8px 0 16px;
  p {
    font-family: ${(props) => props.theme.text.primaryFont};
    margin: 0;
  }
  a {
    color: ${(props) => props.theme.text.fontColor};
  }
`;

const ContactCard: React.FunctionComponent = () => {
  const t = useMessageGetter('');
  const tContact = useMessageGetter('home.grid.contact');
  const [{ building }, dispatch] = useKennoTenant();
  const [{ menu }] = useApp();

  useEffect(() => {
    loadBuilding(dispatch);
  }, [dispatch]);

  const emergencyNumber = building.data?.maintenanceCompany.emergencyNumber;
  const maintenanceCompanyName = building.data?.maintenanceCompany.name;

  const MaintenanceCompanyInfo = () => {
    if (building.loadState === LOAD_STATES.BUSY) {
      return <Loader minHeight={100} />;
    }
    if (!emergencyNumber && !maintenanceCompanyName) {
      return (
        <TextContainer>
          <p>{t('housing.contacts.maintenanceNotFound')}</p>
        </TextContainer>
      );
    }
    return (
      <TextContainer>
        {maintenanceCompanyName && <p>{maintenanceCompanyName}</p>}
        {emergencyNumber && (
          <p>
            <a href={`tel: ${emergencyNumber}`} aria-label={t('housing.contacts.emergencyphone.maintenance.aria')}>
              {`${t('housing.contacts.emergency')}: ${t('housing.contacts.phonenumber')} ${emergencyNumber}`}
            </a>
          </p>
        )}
      </TextContainer>
    );
  };

  return (
    <Card
      title={tContact('title')}
      background={theme().colors.apila}
      mainButton={
        <LinkButton
          size="small"
          background="transparent"
          to={getMenuItemPathBySlug(menu.items, Slugs.CONTACT_INFO)}
          iconRight
          icon="arrowForward"
        >
          {tContact('action.label')}
        </LinkButton>
      }
    >
      <FlexColumn>
        <H6>{tContact('customer_service')}</H6>
        <Divider />
        <TextContainer>
          <p>
            {t('housing.contacts.customerservicename')}{' '}
            <a
              href={`mailto: ${t('footer.housing.customerservice.email')}`}
              aria-label={t('housing.contacts.email.customerservice.aria')}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('footer.housing.customerservice.email')}
            </a>
          </p>
          <p>
            {t('housing.contacts.phonenumber')}&nbsp;
            <a
              href={`tel: ${t('footer.housing.customerservice.phone')}`}
              aria-label={t('housing.contacts.phone.customerservice.aria')}
            >
              {t('footer.housing.customerservice.phone')}
            </a>
          </p>
          <p>{tContact('customer_service_active', { hour_range: '9-15' })}</p>
        </TextContainer>
        <FlexColumn>
          <H6>{tContact('maintenance')}</H6>
          <Divider />
          <MaintenanceCompanyInfo />
        </FlexColumn>
        <H6>{tContact('manager')}</H6>
        <Divider />
        <TextContainer>
          <p>{t('housing.contacts.descriptionAbove')}</p>
          {/*             <p>{housing.manager.personName}</p>
            <p>
              <a href={`mailto:${housing.manager.personEmail}`}>{housing.manager.personEmail}</a>
            </p> */}
        </TextContainer>
      </FlexColumn>
    </Card>
  );
};

export default ContactCard;
